import { ulid } from 'ulid';

/**
 * All entity IDs are `{prefix}_{ulid}` strings (Stripe-style). ULIDs are lexicographically
 * sortable by creation time, which keeps D1 range scans and pagination cursors cheap without a
 * separate `created_at` index for ordering.
 */
export const ID_PREFIXES = {
  tenant: 'tenant',
  platformAdmin: 'padm',
  clientUser: 'cu',
  clientUserInvite: 'cuinv',
  buyer: 'buyer',
  role: 'role',
  apiKey: 'key',
  domain: 'dom',
  event: 'evt',
  session: 'ses',
  ticketType: 'tt',
  seatMap: 'seatmap',
  seatSection: 'sec',
  seat: 'seat',
  seatHold: 'hold',
  promoCode: 'promo',
  addOn: 'addon',
  customQuestion: 'q',
  waitlistEntry: 'wl',
  order: 'ord',
  orderItem: 'oi',
  ticket: 'tix',
  payment: 'pay',
  refund: 'ref',
  dispute: 'dsp',
  ledgerEntry: 'le',
  ledgerTransaction: 'ltx',
  payout: 'payout',
  plan: 'plan',
  planAssignment: 'passign',
  usageEvent: 'usage',
  invoice: 'inv',
  invoiceLine: 'invln',
  creditTopup: 'credittopup',
  webhookEvent: 'whevt',
  webhookDelivery: 'whdlv',
  notification: 'notif',
  auditLog: 'audit',
  idempotencyKey: 'idem',
} as const;

export type EntityKind = keyof typeof ID_PREFIXES;

export function generateId(kind: EntityKind): string {
  return `${ID_PREFIXES[kind]}_${ulid().toLowerCase()}`;
}

export function isIdOfKind(id: string, kind: EntityKind): boolean {
  return id.startsWith(`${ID_PREFIXES[kind]}_`);
}

/** Extracts the prefix from an ID, e.g. "evt" from "evt_01hq...". Returns null if malformed. */
export function prefixOf(id: string): string | null {
  const idx = id.indexOf('_');
  return idx === -1 ? null : id.slice(0, idx);
}
